import {Form, Input} from 'antd';
import FadeEffect from 'components/animation/fadeEffect';
import plusIcon from 'images/plus-circle.png';
import deleteIcon from 'images/delete.svg';
import {fieldRules} from 'utils/helper';
import styles from '../rewardSchemeTabs/newRewardSchemes.module.scss';

export const RewardInstructions = ({form}) => {
  const instructions = Form.useWatch('instructions', form) || [];

  return (
    <div>
      <h1 className={styles['top-header-text']}>Reward Instructions</h1>
      <Form.List name="instructions">
        {(fields, {add, remove}) => (
          <>
            {fields.map(({key, name: fieldName}, index) => (
              <FadeEffect key={key}>
                <div className={styles['key-facts']} key={key}>
                  <div>
                    <Form.Item
                      label="Title"
                      name={[fieldName, 'titleText']}
                      rules={[fieldRules('title is required')]}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      label="Description"
                      name={[fieldName, 'descriptionText']}
                      rules={[fieldRules('description is required')]}>
                      <Input.TextArea rows={4} />
                    </Form.Item>
                    {(!instructions[index]?.titleText ||
                      !instructions[index]?.descriptionText) && (
                      <span className={styles.warning}>
                        Please note both fields are required
                      </span>
                    )}
                  </div>
                  <img
                    onClick={() => remove(fieldName)}
                    src={deleteIcon}
                    alt=""
                  />
                </div>
              </FadeEffect>
            ))}
            <div
              onClick={() => add({titleText: '', descriptionText: ''})}
              className={styles['add-button']}>
              <img src={plusIcon} alt="" />
              <h1>Add Instruction</h1>
            </div>
          </>
        )}
      </Form.List>
    </div>
  );
};
